import { HttpClient } from '@angular/common/http';
import { CommerceLandingPort } from '../../../domain/commerce-registry/ports/commerce-landing.port';
import { FirebaseCommerceLandingAdapter } from '../adapters/firebase-commerce-landing.adapter';
import { MockCommerceLandingAdapter } from '../adapters/mock-commerce-landing.adapter';
import { ENVIRONMENT } from '../../../../environments/environment';

export function commerceLandingPortFactory(http: HttpClient): CommerceLandingPort {
  return ENVIRONMENT.firebase?.databaseURL?.trim()
    ? new FirebaseCommerceLandingAdapter(http)
    : new MockCommerceLandingAdapter();
}
